import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Paper, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const MediaSearchBox = function MediaSearchBox({
  value = '',
  onChange = () => {},
}) {
  const intl = useIntl();
  return (
    <Paper elevation={3} sx={{ borderRadius: 25, width: '20%' }}>
      <TextField
        fullWidth
        size="small"
        placeholder={intl.messages.SEARCH}
        value={value}
        onChange={onChange}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'unset',
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          style: {
            paddingLeft: '6px',
            borderRadius: 25,
          },
        }}
      />
    </Paper>
  );
};

MediaSearchBox.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default MediaSearchBox;
